import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// All API calls use relative URLs (e.g. /api/invoices) so they go through
// the CRA dev proxy (package.json "proxy": "http://localhost:8000").
// This works from the Replit preview pane, a new tab, and external browsers
// because the proxy runs server-side and forwards /api/* to the backend.
// Only set an explicit baseURL if a REACT_APP_BACKEND_URL is provided.
if (process.env.REACT_APP_BACKEND_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
  console.log('Axios configured with baseURL:', process.env.REACT_APP_BACKEND_URL);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
